module.exports = __webpack_public_path__ + "static/media/ESP.f949d75e.jpg";